import { isNil } from 'lodash'

import TypeString from '#/components/FormatCell/Types/string'

type Route = {
  status: string
  text: string
}

type Props = {
  value: Route
}

const TypeRoute = ({ value }: Props) => {
  if (isNil(value?.text)) return <span>-</span>

  // @ts-ignore
  return <TypeString value={value?.text} />
}

export { TypeRoute }
